<div class="modal-backdrop"></div>
<div class="modal-dialog">
  <div class="modal-content modal-aviso-regras">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="material-symbols-outlined">info</i>
        Mais obras disponíveis para você
      </h4>
    </div>

    <div class="modal-body">
      <div class="modal-content-wrapper">
        <div class="logo-container">
          <i class="material-symbols-outlined warning-icon">lightbulb</i>
        </div>

        <h5 class="aviso-question">
          Atualização importante nas regras de exibição
        </h5>

        <p class="aviso-description">
          Ampliamos a quantidade de oportunidades disponíveis na plataforma.
        </p>

        <div class="info-list">
          <div class="info-item">
            <i class="material-icons">schedule</i>
            <p>
              A partir de agora, obras sem atualização recente permanecem visíveis por <strong>6 meses</strong> (antes eram 3 meses).
            </p>
          </div>

          <div class="info-item">
            <i class="material-icons">trending_up</i>
            <p>
              Essa mudança permite que você acompanhe <strong>mais oportunidades</strong> sem deixar de respeitar os critérios de atualização.
            </p>
          </div>
        </div>

        <div class="aviso-info">
          <p>
            Após o período de 6 meses, caso não tenham novas atualizações, as obras deixarão de ser exibidas até passarem por uma nova revisão.
          </p>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-confirmar" (click)="onClose()">Entendi</button>
    </div>
  </div>
</div>
